import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { GroupBase, OptionsOrGroups } from 'react-select';
import { $colors } from 'src/theme/colors';
import { SimpleSelectDataItem } from 'src/types';

type Props = {
  testID?: string;
  placeholder: string;
  options: OptionsOrGroups<unknown, GroupBase<unknown>> | undefined;
  onChange: (value: any) => void;
  selectedValue: string | undefined | null;
  hasError?: boolean;
};

export const SelectWithSearch: React.FC<Props> = ({
  selectedValue,
  onChange,
  options,
  placeholder,
  hasError,
  testID = 'SelectWithSearch',
}) => {
  const extraClasses = hasError ? 'text-red-500' : 'text-primary';

  const { t } = useTranslation();

  const onSelected = useCallback(
    (selected) => {
      onChange(selected.value);
    },
    [onChange],
  );
  return (
    <Select
      options={options}
      onChange={onSelected}
      value={options?.find((item) => (item as unknown as SimpleSelectDataItem).value === selectedValue)}
      placeholder={t(placeholder)}
      className={`w-full py-2  focus-within:text-gray-600  font-light text-lg  ${extraClasses}`}
      styles={{
        singleValue: (provided) => ({ ...provided, color: hasError ? $colors.error : $colors.primary }),
        dropdownIndicator: (provided) => ({ ...provided, color: hasError ? $colors.error : $colors.primary }),
        placeholder: (provided) => ({ ...provided, color: hasError ? $colors.error : undefined }),
        control: (provided) => ({ ...provided, borderColor: hasError ? $colors.error : undefined }),
      }}
      noOptionsMessage={() => t('select-no-options')}
    />
  );
};
